import {default as init} from "surveylabJsAssets/chart/charts";
import {setDefaultOptions} from "sdbbJsAssets/chart/charts";
import registerProfileChart from './plugin/profile-chart';

export default function () {
    setDefaultOptions({
        // Use blue as primary color (matches PDF), overriding any pink defaults
        colors: ['#7cb5ec'],
    });
    // Register application-specific chart plugins before initializing
    registerProfileChart();
    init();
}